import React, { useState } from 'react';
import Table from './Table';
import CustomCard from '../CustomCard';
import ExportButton from './ExportButton';
import DivStart from '../div/DivStart';
import DivBetween from '../div/DivBetween';

const CardTable = (props) => {
  const [tableData, setTableData] = useState();

  function prepareTitle() {
    if (props.tableExport) {
      return (
        <DivBetween>
          <div className="fw-bold w-100 me-2" >
            {props.title || props.tittle}
          </div>

          {tableData && (
            <ExportButton
              columns={tableData.columns}
              rows={tableData.rows}
              filename={props.exportFileName || 'eksport'}
            />
          )}
        </DivBetween >


      );
    }

    return props.title || props.tittle;
  }

  return (
    <>
      <CustomCard
        width={props.width}
        className={props.className}
        shadow={props.shadow}
        withoutHeader={props.withoutHeader}
        title={prepareTitle()}
      >
        {props.columns ? (
          <Table
            setLoader={props.setLoader}
            source={props.source}
            columns={props.columns}
            reload={props.reload}
            additionalFilter={props.additionalFilter}
            checked={props.checked}
            showAlways={props.showAlways}
            readOnly={props.readOnly}
            disableRule={props.disableRule}
            defaultRowsCount={props.defaultRowsCount}
            onReload={props.onReload}
            setChecked={props.setChecked}
            initData={props.initData}
            striped={props.striped}
            tableHeader={props.tableHeader}
            pagination={props.pagination}
            searchConf={props.searchConf}
            dataUpdated={setTableData}
            externalState={props.externalState}
            externalState2={props.externalState2}
          />
        ) : (
          ''
        )}

        {props.children}
      </CustomCard>
    </>
  );
};

export default CardTable;
